import { render, staticRenderFns } from "./detail-component-contact.vue?vue&type=template&id=454f8574&scoped=true"
import script from "./detail-component-contact.vue?vue&type=script&lang=ts"
export * from "./detail-component-contact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f8574",
  null
  
)

export default component.exports